module.exports = __webpack_public_path__ + "img/15.3786130b.png";